import { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
import { Grid } from '@material-ui/core';
import { MessageBoxSpace } from 'src/components/general';
import {
  closeSignatureAlerts,
  SignatureAlerts,
} from 'src/store/signature/actions';

export const SingAlertController = ({
  pinRequested,
  showAlerts,
  alertType,
  closeSignatureAlertsAction,
}: Props): JSX.Element => {
  const [showDefaulMessage, setShowDefaulMessage] = useState(true);

  const handleCloseMessage = () => setShowDefaulMessage(false);
  if (!pinRequested) {
    return (
      <Grid item xs={12}>
        {showDefaulMessage && (
          <MessageBoxSpace
            message="Verifica la información a continuación."
            variant="info"
            onCloseClick={handleCloseMessage}
            data-testid="info-card"
          />
        )}
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      {showAlerts && alertType === SignatureAlerts.PIN_REQUEST_ERROR && (
        <MessageBoxSpace
          message="No hemos podido enviar el PIN. Por favor intenta nuevamente."
          variant="error"
          onCloseClick={closeSignatureAlertsAction}
          data-testid="error-card"
        />
      )}
      {showAlerts && alertType === SignatureAlerts.PIN_REQUEST_SUCCESS && (
        <MessageBoxSpace
          message="El PIN se ha enviado a tu correo electrónico."
          variant="success"
          onCloseClick={closeSignatureAlertsAction}
          data-testid="success-card"
        />
      )}
      {showAlerts && alertType === SignatureAlerts.PIN_VALIDATION_ERROR && (
        <MessageBoxSpace
          message="No se pudo firmar el documento, por favor intenta nuevamente."
          variant="error"
          onCloseClick={closeSignatureAlertsAction}
          data-testid="error-validation-card"
        />
      )}
    </Grid>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  pinRequested: boolean;
  showAlerts: boolean;
  alertType: string;
} => ({
  pinRequested: state.signature.pinRequested,
  showAlerts: state.signature.showAlerts,
  alertType: state.signature.alertType,
});

const reduxActions = {
  closeSignatureAlertsAction: closeSignatureAlerts,
};

const connector = connect(mapStateToProps, reduxActions);
type Props = ConnectedProps<typeof connector>;

export default connector(SingAlertController);
